'use client';

export default function PaginatedPostsLoader() {
  const articles = Array.from({ length: 20 });
  return (
    <div className='grid gap-8 sm:grid-cols-2'>
      {articles &&
        articles.map((_article, index) => (
          <div
            key={index}
            className='flex w-full animate-pulse flex-row gap-5 md:gap-6'
          >
            {/* Left Section: Image Skeleton */}
            <div className='min-w-fit'>
              <div className='h-[120px] w-[120px] rounded-lg bg-gray-300 md:h-[154px] md:w-[154px]'></div>
            </div>

            {/* Right Section: Content Skeleton */}
            <div className='flex w-full flex-col gap-3 md:gap-3.5'>
              {/* Tags Skeleton */}
              <div className='flex w-full gap-2'>
                <div className='h-6 w-16 rounded-md bg-gray-300'></div>
                <div className='h-6 w-20 rounded-md bg-gray-300'></div>
                <div className='h-6 w-12 rounded-md bg-gray-300'></div>
              </div>

              {/* Heading Skeleton */}
              <div className='h-6 w-3/4 rounded-md bg-gray-300'></div>

              {/* Excerpt Skeleton */}
              <div className='hidden sm:block'>
                <div className='mb-1 h-4 w-full rounded-md bg-gray-300'></div>
                <div className='h-4 w-5/6 rounded-md bg-gray-300'></div>
              </div>

              {/* Read Time and Date Skeleton */}
              <div className='h-4 w-1/3 rounded-md bg-gray-300'></div>
            </div>
          </div>
        ))}
    </div>
  );
}
